.undo-icon {
  display: block;
  margin: auto;
}
